module.exports = __webpack_public_path__ + "static/media/ListMagnifyingGlass.07357b2a.svg";